export default __webpack_public_path__ + "static/aws-tablet-5d81ad399ba718ce5fdb9dd37ccdb77a.jpg";